module.exports = __webpack_public_path__ + "img/dog.a0cd2886.svg";